export const GET_WS_PRICE = Symbol("Get realtime  Price");
export const CLOSE_WS_PRICE = Symbol("Close realtime price socket");
export const GET_DAILY_OHLCV = Symbol("Gets Open, High, Low, Close and Volume");
export const GET_ASSET = Symbol("Gets a cryptocurrency asset");
export const GET_STATISTICS = Symbol("Get crypto statistics");
export const GET_TOP_ASSETS = Symbol("Get crypto assets");
export const SEARCH_ASSET = Symbol("Search cryptocurrency asset");
export const GET_TRADING_SIGNALS = Symbol("Get crypto trading signals");
export const GET_NEWS = Symbol("Get crypto news");
export const STREAM_TICKER = Symbol("Stream crypto ticker");

// Pricing
export const STREAM_PRICES = Symbol("Stream crypto prices");
export const STREAM_TOP_PRICES = Symbol("Stream top crypto prices");
export const STREAM_PRICE = Symbol("Stream crypto price");
